// extracted by mini-css-extract-plugin
module.exports = {"main":"CountersinkHoles_main__37vME","Type":"CountersinkHoles_Type__1KO4K","imgContainer":"CountersinkHoles_imgContainer__3MdeW"};